import React from 'react';
import { motion } from 'framer-motion';

export const EmptyState: React.FC = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4 }}
    className='p-10 flex flex-col items-center justify-center text-center text-light/60 gap-4'
  >
    <svg
      width='120'
      height='120'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      className='text-gray-400'
    >
      <path d='M3 6h18M3 12h18M3 18h18' />
    </svg>

    <div className='text-lg font-semibold text-main'>No transactions yet</div>
    <div className='text-sm text-light/70 max-w-[250px]'>
      Looks like you haven't made any payments yet. Your transactions will appear here once you do!
    </div>
  </motion.div>
);

